import { useState, useCallback } from 'react';

export default function useConfirmDialog(initial = { open: false, title: '', message: '', onConfirm: null }) {
  const [confirmState, setConfirmState] = useState(initial);

  const openConfirm = useCallback((title, message, onConfirm) => {
    setConfirmState({ open: true, title, message, onConfirm });
  }, []);

  const closeConfirm = useCallback(() => {
    setConfirmState({ open: false, title: '', message: '', onConfirm: null });
  }, []);

  return { confirmState, setConfirmState, openConfirm, closeConfirm };
}




